import { createFileRoute } from '@tanstack/react-router';
import { ComingSoon } from '@/features/placeholder/ComingSoon.tsx';

// Placeholder until this area is ported — see docs/features/*-inventory.md.
export const Route = createFileRoute('/_app/inventory')({
  component: InventoryPage,
});

function InventoryPage() {
  return <ComingSoon slug="inventory" />;
}
